export const CLIENTS_FETCH = 'REFERRAL/CLIENTS_FETCH'
export const CLIENTS_SET_FILTERS = 'REFERRAL/CLIENTS_SET_FILTERS'
export const CLIENTS_RESET_DATA = 'REFERRAL/CLIENTS_RESET_DATA'
export const CLIENTS_FILTERS_APPLY = 'REFERRAL/CLIENTS_FILTERS_APPLY'
export const CLIENTS_SET_DATA = 'REFERRAL/CLIENTS_SET_DATA'
export const CLIENTS_UPDATE_CLIENT = 'REFERRAL/CLIENTS_UPDATE_CLIENT'
export const CLIENTS_UPDATE_DATA = 'REFERRAL/CLIENTS_UPDATE_DATA'
